<template>
  <div>
    <AccordionCard :state="cards.zsLocationState">
      <template v-slot:header>
        {{ $t('zsLocationState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('zsLocationState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.zsLocationState"
            :options="getEnumValues('HouseLocationState')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.zsWithCoverAttachments">
      <template v-slot:header>
        {{ $t('zsWithCoverAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('zsWithCoverAttachments') }}
        </div>
        <div class="flex-column select">
          <p>{{ $t('upload_addtional_images') }}</p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="getReportTemplateImages[21].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.zsWithCoverAttachments"
            attachmentType="zsWithCoverAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isZsWithCoverAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="zsWithCoverAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isZsWithCoverAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.zsWithoutCoverAttachments">
      <template v-slot:header>
        {{ $t('zsWithoutCoverAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('zsWithoutCoverAttachments') }}
        </div>
        <div class="flex-column select">
          <p>{{ $t('upload_addtional_images') }}</p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="getReportTemplateImages[22].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.zsWithoutCoverAttachments"
            attachmentType="zsWithoutCoverAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isZsWithoutCoverAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="zsWithoutCoverAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isZsWithoutCoverAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.newZsRequiredState">
      <template v-slot:header>
        {{ $t('newZsRequiredState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('newZsRequiredState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.newZsRequiredState"
            :options="getEnumValues('NewZsRequiredState')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.zsSubDistributionRequiredState">
      <template v-slot:header>
        {{ $t('zsSubDistributionRequiredState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('zsSubDistributionRequiredState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.zsSubDistributionRequiredState"
            :options="getEnumValues('YesNo')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>

      <div class="flex-row" v-if="project.measurement.ac.zsSubDistributionRequiredState === 'YES'">
        <div class="flex-column name">{{ $t('zsSubDistributionRequiredNotes') }}</div>
        <div class="flex-column select">
          <Textarea
            v-model="project.measurement.ac.zsSubDistributionRequiredNotes"
            :autoResize="true"
            rows="5"
            cols="30"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.netType">
      <template v-slot:header>
        {{ $t('netType') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('netType') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.netType"
            :options="getEnumValues('NetType')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.zsOptionalAttachments">
      <template v-slot:header>
        {{ $t('optionalAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('optionalAttachments') }}
        </div>
        <div class="flex-column select">
          {{ $t('optional_notes_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.zsOptionalAttachments"
            attachmentType="zsOptionalAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isZsOptionalAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="zsOptionalAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isZsOptionalAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.zsNotes">
      <template v-slot:header>
        {{ $t('optional_notes') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('optional_notes') }}
        </div>
        <div class="flex-column select">
          {{ $t('optional_notes_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <Textarea
            v-model="project.measurement.ac.zsNotes"
            :autoResize="true"
            rows="5"
            cols="30"
          />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AccordionCard from '@/components/AccordionCard';
import DropzoneUpload from '@/components/DropzoneUpload';
import AttachmentGallery from '@/components/AttachmentGallery';
import SelectButton from 'primevue/selectbutton';
import Textarea from 'primevue/textarea';

export default {
  name: 'LocationAndCablePath',
  components: {
    AccordionCard,
    SelectButton,
    Textarea,
    DropzoneUpload,
    AttachmentGallery,
  },
  props: {
    project: { type: Object },
    cards: { type: Object },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isZsWithCoverAttachmentsUploadComplete: false,
      isZsWithoutCoverAttachmentsUploadComplete: false,
      isZsOptionalAttachmentsUploadComplete: false,
    };
  },
  computed: { ...mapGetters(['getEnumValues', 'getReportTemplateImages']) },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isZsWithCoverAttachmentsUploadComplete = true;
          this.isZsWithoutCoverAttachmentsUploadComplete = true;
          this.isZsOptionalAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>
